<app-core-popup
  [header]="'change-kdv-popup.popup-header' | translate"
  [dialogStyle]="{ width: '40vw' }"
  [saveText]="'change-kdv-popup.continue' | translate"
  (chooseOn)="continueF()"
  (closeOn)="closePopup()"
  #corePopup
>
  <div>
    <p class="text-muted">{{ "change-kdv-popup.description" | translate }}</p>

    @for(rate of kdvRates; track rate) {
    <div class="rate-group">
      <label for=""
        >{{ "change-kdv-popup.old-kdv" | translate }}: %{{
          rate?.kdvRateLabel
        }}</label
      >

      <div class="select-group">
        <label class="required-star" for=""
          >{{ "change-kdv-popup.new-kdv" | translate }}:</label
        >
        <p-dropdown
          [options]="allKDVRate"
          [(ngModel)]="rate.newKdvRateId"
          [filter]="true"
          [placeholder]="'change-kdv-popup.new-kdv' | translate"
          [style]="{ width: '200px' }"
          appendTo="body"
        ></p-dropdown>
      </div>
    </div>
    }
  </div>
</app-core-popup>

<p-dialog
  [(visible)]="visible"
  [header]="'change-kdv-popup.popup-header' | translate"
  [modal]="true"
  [style]="{ width: '40vw' }"
>
  <div class="d-flex justify-content-center align-items-center">
    <div>
      <ul class="kdv-list">
        <li *ngFor="let change of kdvRates" class="kdv-item">
          <span class="kdv-count"
            >{{ change.count }}
            {{ "change-kdv-popup.quantity" | translate }}</span
          >
          <span class="kdv-rate"
            >{{ "change-kdv-popup.kdv" | translate }} %{{
              change.newKdvRateLabel
            }}</span
          >
        </li>
      </ul>

      <p class="confirmation-text">
        {{ "change-kdv-popup.confirmation-text" | translate }}
      </p>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      type="button"
      class="btn btn-danger me-2"
      (click)="cancelVisible()"
    >
      {{ "common.cancel" | translate }}
    </button>
    <button type="button" class="btn btn-success" (click)="save()">
      {{ 'change-kdv-popup.continue' | translate }}
    </button>
  </ng-template>
</p-dialog>
